import * as React from 'react';

import { cn } from '@/lib/utils';

import { CONTAINER_PADDING, CONTAINER_WIDTHS } from './tokens';

interface ContainerProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  size?: keyof typeof CONTAINER_WIDTHS;
  padding?: keyof typeof CONTAINER_PADDING;
  children?: React.ReactNode;
}

const Container = React.forwardRef<HTMLElement, ContainerProps>(
  ({ as: Component = 'div', size = 'xl', padding = 'md', className, children, ...props }, ref) => {
    // Safe access since padding is constrained to keyof typeof CONTAINER_PADDING
    const safePadding = CONTAINER_PADDING[padding];
    const safeWidth = CONTAINER_WIDTHS[size];
    return (
      <Component
        ref={ref}
        className={cn('mx-auto w-full', safeWidth, safePadding, className)}
        {...props}
      >
        {children}
      </Component>
    );
  }
);
Container.displayName = 'Container';

export { Container };
